<template>
  <div>
      <div class="title"> Double Pendulum </div>
      <div class="date"> April 15th, 2021 </div>

      <div class="content">
		
        <iframe width="916" height="515" src="https://www.youtube.com/embed/n7JK4Ht8k8M" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>


        <div> 
            This is the first time I used the python package
            <div class="code"> manim </div>
             to make a visualization. I have no idea how <div class="code"> manim </div> works, it really is magic to me.
             This idea came to me a few days after I watched a video showing the basin's of attraction for a pendulum in a magnetic field. 
             Fractals are really cool. I'm going to try to zoom into the fractal later when I get the chance.
        </div>


      </div>
  </div>
</template>

<script>

export default {
  name: 'DoublePendulum',
  mounted: () => {
  }
}

</script>

<style scoped>

.code {
    display: inline-block;
    background: #f0f0f0;
    font-family: "Roboto Mono", monospace;
    padding: 0px 3px;
    font-size: 0.8em;
}

</style>
